import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePlotContext } from '../hooks';
function yTranslation(position, height) {
    switch (position) {
        case 'top': {
            return 20;
        }
        case 'bottom': {
            return height + 64;
        }
        default: {
            throw new Error(`Unknown ${JSON.stringify(position)} position`);
        }
    }
}
export default function Heading({ title, titleStyle, titleClass, subtitle, subtitleStyle, subtitleClass, position = 'top', }) {
    const { width, height, bottom } = usePlotContext();
    const defaultTitleStyle = {
        textAnchor: 'middle',
        fontSize: '16px',
        fontWeight: 'bold',
    };
    const defaultSubtitleStyle = {
        textAnchor: 'middle',
        fontSize: '14px',
        color: 'gray',
    };
    const bottomHeigth = height - bottom;
    const y = yTranslation(position, bottomHeigth);
    return (_jsxs("g", Object.assign({ transform: `translate(${width / 2}, ${y})` }, { children: [_jsx("text", Object.assign({ style: { ...defaultTitleStyle, ...titleStyle }, className: titleClass }, { children: title }), void 0),
            subtitle && (_jsx("text", Object.assign({ transform: "translate(0, 20)", style: { ...defaultSubtitleStyle, ...subtitleStyle }, className: subtitleClass }, { children: subtitle }), void 0))] }), void 0));
}
//# sourceMappingURL=Heading.js.map